module.exports = __webpack_public_path__ + "img/832336.24ecf82e.jpg";